"use strict";
/**
 * 判断当前 APP
 * 需要传递 utm_campaign 参数
 *
 * ### Example
 * ```
 * const app = getApp('AgroupBgroupD300Gmine_walletH0');
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUA = {
    group: /meituangroup/,
    // 外卖为了兼容5的版本，故没有用包名
    waimai: /meituanwaimai-c|takeoutnew/,
    waimaiB: /meituanwaimai(-b|business)/,
    'dianping-nova': /com\.dianping\./,
    'meituanyouxuan_app': /meituanyouxuan_app/,
    conch: /conch/,
    movie: /movie/,
    QCSC: /qcsc\/com\.meituan/,
    weibo: /weibo/,
    weixin: /micromessenger/,
    mqq: /qq\//,
    alipay: /alipayclient/,
    daxiang: / xm\//,
    saori: /saori/,
    moma: /moma/,
    retail: /iretail|retail\.c/,
    zhenguo: /phoenix/,
    mtmaicai: /com\.(baobaoaichi\.imaicai|meituan\.(imaicai\.ep|retail\.v\.android|retail\.v\.android))/
};
function getApp(campaign, userAgent) {
    var appName = Object.keys(exports.AppUA);
    var ua = (userAgent || navigator.userAgent).toLowerCase();
    for (var i = 0, l = appName.length; i < l; i++) {
        if (exports.AppUA[appName[i]].test(ua)) {
            return appName[i];
        }
    }
    if (campaign) {
        var posA = campaign.indexOf('A') + 1;
        var posB = campaign.indexOf('B');
        posB = posB === -1 ? campaign.length : posB;
        return campaign.substring(posA, posB);
    }
    return /titansx/.test(ua) ? 'unknown-app' : 'web';
}
exports.getApp = getApp;
